<template>
    <div class="about-us-container">
        <div class="about-top-info">
            <div class="about-img-container">
                <img
                    class="about-us-img"
                    :src="aboutUsInfo.imgUrl"
                    alt=""
                />
            </div>
            <div class="about-us-text-container">
                <p class="about-title-text">
                    <span>关于</span>
                    <span class="blue-text">我们</span>
                </p>
                <p class="about-sub-title-text">AUBOT US</p>
                <p class="about-main-text" style="height:500px;overflow:auto">
                    {{ aboutUsInfo.description }}
                </p>
                <template v-if="hideShowMoreBtn">
                    <div class="about-us-more-btn-container">
                        <router-link to="/aboutUs">
                            <el-button class="about-us-more-btn" plain
                                >了解更多 ++</el-button
                            >
                        </router-link>
                    </div>
                </template>
            </div>
        </div>
        <div class="about-bottom-info">
            <el-row>
                <el-col class="one-about-col" :span="6">
                    <div class="one-aubot-left-line" />
                    <div class="one-about-info-item">
                        <p>公司创立于</p>
                        <p class="special-info">
                            <countTo
                                :startVal="0"
                                :endVal="aboutUsInfo.beginYear"
                                :duration="1500"
                                separator=""
                                class="number-text"
                            />
                            <span class="small-text">年</span>
                        </p>
                    </div>
                </el-col>
                <el-col class="one-about-col" :span="6">
                    <div class="one-aubot-left-line" />
                    <div class="one-about-info-item">
                        <p>久经市场考验达</p>
                        <p class="special-info">
                            <countTo
                                :startVal="0"
                                :endVal="
                                    new Date().getFullYear() -
                                    aboutUsInfo.beginYear
                                "
                                :duration="1500"
                                separator=""
                                class="number-text"
                            />
                            <span class="small-text">年</span>
                        </p>
                    </div>
                </el-col>
                <el-col class="one-about-col" :span="6">
                    <div class="one-aubot-left-line" />
                    <div class="one-about-info-item">
                        <p>为客户创造价值</p>
                        <p class="special-info">
                            <countTo
                                :startVal="0"
                                :endVal="aboutUsInfo.customerValue"
                                :duration="1500"
                                class="number-text"
                            />
                            <span class="small-text">万</span>
                        </p>
                    </div>
                </el-col>
                <el-col class="one-about-col" :span="6">
                    <div class="one-aubot-left-line" />
                    <div class="one-aubot-right-line" />
                    <div class="one-about-info-item">
                        <p>合作客户</p>
                        <p class="special-info">
                            <countTo
                                :startVal="0"
                                :endVal="aboutUsInfo.cooperativeCustomers"
                                :duration="1500"
                                separator=""
                                class="number-text"
                            />
                            <span class="small-text">家</span>
                        </p>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import countTo from "vue-count-to";

import { GETABOUTUSINFO } from "../../utils/uriList";

export default {
    props: ["hideShowMoreBtn"],
    components: { countTo },
    mounted() {
        this.getAountUsInfo();
    },
    data() {
        return {
            aboutUsInfo: {},
        };
    },
    methods: {
        async getAountUsInfo() {
            const response = await this.$http.get(GETABOUTUSINFO);
            if (response.data.code === 0) {
                this.aboutUsInfo = response.data.data;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/components/Home/AboutUs.scss";
</style>
